<template>
  <div class="back-to-top">
    <i class="icon icon--ba-back-to-top"
       @click="onBackToTopClick"></i>
  </div>
</template>

<script>
export default {
  name: 'BaBackToTop',
  props: {
    refName: {
      type: String,
      required: true
    }
  },
  methods: {
    onBackToTopClick () {
      if (this.refName) {
        let component = this
        let target

        while (component) {
          target = component.$refs[this.refName]

          if (target) {
            if (target.$el) {
              target = target.$el
            }
            break
          }
          component = component.$parent
        }

        if (target) {
          let duration = 500
          if (target.scrollTop === 0) return

          const cosParameter = target.scrollTop / 2
          let scrollCount = 0
          let oldTimestamp = null

          let step = (newTimestamp) => {
            if (oldTimestamp !== null) {
              scrollCount += Math.PI * (newTimestamp - oldTimestamp) / duration
              if (scrollCount >= Math.PI) {
                target.scrollTop = 0
                return
              }
              target.scrollTop = cosParameter + cosParameter * Math.cos(scrollCount)
            }
            oldTimestamp = newTimestamp
            window.requestAnimationFrame(step)
          }
          window.requestAnimationFrame(step)
        }
        this.$emit('onBackToTopClick')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.back-to-top {
  position: relative;
  cursor: pointer;
  margin: 0 auto;
  width: 40px;
  height: 40px;

  i.icon {
    position: relative;
    background-color: #ffffff;
    border-radius: 50%;
    box-shadow: 0 7px 8px -3px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(0, 0, 0, 0.06);
    transition: background-color 0.2s ease;

    &:hover {
      background-color: #efefef;
    }
  }
}
</style>
